"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getInboxRules_1 = require("./getInboxRules");
var createInboxRuleFromStoreEditState_1 = require("./helpers/createInboxRuleFromStoreEditState");
var newInboxRuleService_1 = require("../services/newInboxRuleService");
var setInboxRuleService_1 = require("../services/setInboxRuleService");
var resetInboxRuleEdit_1 = require("./resetInboxRuleEdit");
var store_1 = require("../store/store");
var logInboxRuleInformation_1 = require("../utils/logInboxRuleInformation");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('saveInboxRuleEdit')(legacy_1.select({
    optionState: function () { return store_1.default; },
})(function saveInboxRuleEdit(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var inboxRuleId, inboxRule;
        return tslib_1.__generator(this, function (_a) {
            inboxRuleId = state.optionState.inboxRulesEditState.ruleId;
            inboxRule = createInboxRuleFromStoreEditState_1.default(inboxRuleId);
            // If the rule already has an id, that means it is an edited rule
            if (inboxRuleId) {
                return [2 /*return*/, setInboxRuleService_1.default(inboxRule)
                        .then(function (response) {
                        onSuccessfulRuleSave(response, 'SetInboxRule', inboxRule);
                    })
                        .catch(function (error) {
                        return;
                    })];
            }
            // Otherwise it is a new rule
            return [2 /*return*/, newInboxRuleService_1.default(inboxRule)
                    .then(function (response) {
                    onSuccessfulRuleSave(response, 'NewInboxRule', inboxRule);
                })
                    .catch(function (error) {
                    return;
                })];
        });
    });
}));
function onSuccessfulRuleSave(response, ruleActionSource, inboxRule) {
    if (response.WasSuccessful) {
        resetInboxRuleEdit_1.default();
        // re-fetch the rules list if successful
        getInboxRules_1.default();
        logInboxRuleInformation_1.default(inboxRule, ruleActionSource);
    }
}
//# sourceMappingURL=saveInboxRuleEdit.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/saveInboxRuleEdit.js
// module id = 5229
// module chunks = 2